import { render } from "./Gracias.vue?vue&type=template&id=4f6282f9"
import script from "./Gracias.vue?vue&type=script&lang=js"
export * from "./Gracias.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__